/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$('.moreless-button').click(function() {
  $('.moretext').slideToggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});

$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});


function calculateChippings() {
  // Retrieve input values using class names
  const bulkBag = document.getElementsByClassName("bulkBag");
  const bulkBagValue = parseFloat(bulkBag[1].value); // Bulk bag weight in kg
  const width = document.getElementsByClassName("calculateWidth");
  const widthValue = parseFloat(width[1].value); // Width in meters
  const length = document.getElementsByClassName("calculateLength");
  const lengthValue = parseFloat(length[1].value); // Length in meters
  const depth = document.getElementsByClassName("calculateMM");
  const depthValue = parseFloat(depth[1].value) / 1000; // Convert depth from mm to meters

  if (widthValue && lengthValue && depthValue) {
      // Calculate cubic meters
      const total = (widthValue * lengthValue) * depthValue;

      // Weight calculations
      const weightPerCubicMeter = 1700; // Weight per cubic meter in kg
      const weight = total * weightPerCubicMeter;
      const weightNeeded = Math.ceil(weight / bulkBagValue);
      const bulkBagsNeeded = Math.ceil(weightNeeded / 800);

      // Display results
      const responseDiv = document.getElementsByClassName("calcResponse");
      if (responseDiv[1].style.display == "none") {
          responseDiv[1].style.display = "block";
          responseDiv[1].innerHTML = `Cubic Meters: ${total.toFixed(2)}`;
      } else if (responseDiv[1].style.display == "block") {
          responseDiv[1].innerHTML = `Cubic Meters: ${total.toFixed(2)}`;
      }

      const totalweight = document.getElementsByClassName("totalweight");
      totalweight[1].style.display = "block";
      totalweight[1].innerHTML = `Weight (kg): ${weightNeeded}`;

      const bulkBags = document.getElementsByClassName("bulkBags");
      bulkBags[1].style.display = "block";
      bulkBags[1].innerHTML = `Bulk Bags Needed: ${bulkBagsNeeded}`;
  } else {
      console.log("Please ensure all inputs are provided.");
  }
}
function calculateGravel() {
    // Retrieve input values using class names
    const bulkBag = document.getElementsByClassName("bulkBag");
    const bulkBagValue = parseFloat(bulkBag[1].value); // Bulk bag weight in kg
    const width = document.getElementsByClassName("calculateWidth");
    const widthValue = parseFloat(width[1].value); // Width in meters
    const length = document.getElementsByClassName("calculateLength");
    const lengthValue = parseFloat(length[1].value); // Length in meters
    const depth = document.getElementsByClassName("calculateMM");
    const depthValue = parseFloat(depth[1].value) / 1000; // Convert depth from mm to meters
  
    if (widthValue && lengthValue && depthValue) {
        // Calculate cubic meters
        const total = (widthValue * lengthValue) * depthValue;
  
        // Weight calculations
        const weightPerCubicMeter = 1400; // Weight per cubic meter in kg
        const weight = total * weightPerCubicMeter;
        const weightNeeded = Math.ceil(weight / bulkBagValue);
        const bulkBagsNeeded = Math.ceil(weightNeeded / 800);
  
        // Display results
        const responseDiv = document.getElementsByClassName("calcResponse");
        if (responseDiv[1].style.display == "none") {
            responseDiv[1].style.display = "block";
            responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
        } else if (responseDiv[1].style.display == "block") {
            responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
        }
  
        const totalweight = document.getElementsByClassName("totalweight");
        totalweight[1].style.display = "block";
        totalweight[1].innerHTML = `Weight (kg): ${weightNeeded}`;
  
        const bulkBags = document.getElementsByClassName("bulkBags");
        bulkBags[1].style.display = "block";
        bulkBags[1].innerHTML = `Bulk Bags Needed: ${bulkBagsNeeded}`;
    } else {
        console.log("Please ensure all inputs are provided.");
    }
  }
function calculateSand() {
  // Retrieve input values using class names
  const bulkBag = document.getElementsByClassName("bulkBag");
  const bulkBagValue = parseFloat(bulkBag[1].value); // Bulk bag weight in kg
  const width = document.getElementsByClassName("calculateWidth");
  const widthValue = parseFloat(width[1].value); // Width in meters
  const length = document.getElementsByClassName("calculateLength");
  const lengthValue = parseFloat(length[1].value); // Length in meters
  const depth = document.getElementsByClassName("calculateMM");
  const depthValue = parseFloat(depth[1].value) / 1000; // Convert depth from mm to meters

  if (widthValue && lengthValue && depthValue) {
      // Calculate cubic meters
      const total = (widthValue * lengthValue) * depthValue;

      // Weight calculations
      const weightPerCubicMeter = 1550; // Weight per cubic meter in kg
      const weight = total * weightPerCubicMeter;
      const weightNeeded = Math.ceil(weight / bulkBagValue);
      const bulkBagsNeeded = Math.ceil(weightNeeded / 800);

      // Display results
      const responseDiv = document.getElementsByClassName("calcResponse");
      if (responseDiv[1].style.display == "none") {
          responseDiv[1].style.display = "block";
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      } else if (responseDiv[1].style.display == "block") {
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      }

      const totalweight = document.getElementsByClassName("totalweight");
      totalweight[1].style.display = "block";
      totalweight[1].innerHTML = `Weight (kg): ${weightNeeded}`;

      const bulkBags = document.getElementsByClassName("bulkBags");
      bulkBags[1].style.display = "block";
      bulkBags[1].innerHTML = `Bulk Bags Needed: ${bulkBagsNeeded}`;
  } else {
      console.log("Please ensure all inputs are provided.");
  }
}
function calculateSlate() {
  // Retrieve input values using class names
  const bulkBag = document.getElementsByClassName("bulkBag");
  const bulkBagValue = parseFloat(bulkBag[1].value); // Bulk bag weight in kg
  const width = document.getElementsByClassName("calculateWidth");
  const widthValue = parseFloat(width[1].value); // Width in meters
  const length = document.getElementsByClassName("calculateLength");
  const lengthValue = parseFloat(length[1].value); // Length in meters
  const depth = document.getElementsByClassName("calculateMM");
  const depthValue = parseFloat(depth[1].value) / 1000; // Convert depth from mm to meters

  if (widthValue && lengthValue && depthValue) {
      // Calculate cubic meters
      const total = (widthValue * lengthValue) * depthValue;

      // Weight calculations
      const weightPerCubicMeter = 2000; // Weight per cubic meter in kg
      const weight = total * weightPerCubicMeter;
      const weightNeeded = Math.ceil(weight / bulkBagValue);
      const bulkBagsNeeded = Math.ceil(weightNeeded / 800);

      // Display results
      const responseDiv = document.getElementsByClassName("calcResponse");
      if (responseDiv[1].style.display == "none") {
          responseDiv[1].style.display = "block";
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      } else if (responseDiv[1].style.display == "block") {
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      }

      const totalweight = document.getElementsByClassName("totalweight");
      totalweight[1].style.display = "block";
      totalweight[1].innerHTML = `Weight (kg): ${weightNeeded}`;

      const bulkBags = document.getElementsByClassName("bulkBags");
      bulkBags[1].style.display = "block";
      bulkBags[1].innerHTML = `Bulk Bags Needed: ${bulkBagsNeeded}`;
  } else {
      console.log("Please ensure all inputs are provided.");
  }
}
function calculateBreedom() {
  // Retrieve input values using class names
  const bulkBag = document.getElementsByClassName("bulkBag");
  const bulkBagValue = parseFloat(bulkBag[1].value); // Bulk bag weight in kg
  const width = document.getElementsByClassName("calculateWidth");
  const widthValue = parseFloat(width[1].value); // Width in meters
  const length = document.getElementsByClassName("calculateLength");
  const lengthValue = parseFloat(length[1].value); // Length in meters
  const depth = document.getElementsByClassName("calculateMM");
  const depthValue = parseFloat(depth[1].value) / 1000; // Convert depth from mm to meters

  if (widthValue && lengthValue && depthValue) {
      // Calculate cubic meters
      const total = (widthValue * lengthValue) * depthValue;

      // Weight calculations
      const weightPerCubicMeter = 2000; // Weight per cubic meter in kg
      const weight = total * weightPerCubicMeter;
      const weightNeeded = Math.ceil(weight / bulkBagValue);
      const bulkBagsNeeded = Math.ceil(weightNeeded / 800);

      // Display results
      const responseDiv = document.getElementsByClassName("calcResponse");
      if (responseDiv[1].style.display == "none") {
          responseDiv[1].style.display = "block";
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      } else if (responseDiv[1].style.display == "block") {
          responseDiv[1].innerHTML = `Your total in m3: ${total.toFixed(2)}`;
      }

      const totalweight = document.getElementsByClassName("totalweight");
      totalweight[1].style.display = "block";
      totalweight[1].innerHTML = `Weight (kg): ${weightNeeded}`;

      const bulkBags = document.getElementsByClassName("bulkBags");
      bulkBags[1].style.display = "block";
      bulkBags[1].innerHTML = `Bulk Bags Needed: ${bulkBagsNeeded}`;
  } else {
      console.log("Please ensure all inputs are provided.");
  }
}